export const apiUrl = () => {
  const mode = process.env.NODE_ENV;

  switch (mode) {
    case "development":
      return process.env.VUE_APP_LOCAL_BASE_URL;
    case "production":
      return process.env.VUE_APP_PRODUCTION_BASE_URL;
    default:
      return process.env.VUE_APP_PRODUCTION_BASE_URL;
  }
};

export const userUrls = {
  login: "api/users/login",
  logout: "api/users/logout",
  getUser: "api/users/me",
  requestAccess: "api/lab-results/",
};

export const balanceUrls = {
  add: "api/balance/",
  history: "api/balance/",
};

export const hmiUrls = {
  getParameters: "api/predictive/params/",
  getLatestLabParameters: "api/lab-results/",
  saveOperation: (id: number) => `api/operation/${id}/save/`,
};

export const predictionUrls = {
  calculate: "api/predictions/",
  history: "api/predictions/",
};

export const recommendationUrls = {
  add: "api/recommendation/v1/",
  history: "api/recommendation/v1/",
};

export const errorRatesUrls = {
  latest: "api/error-rates/latest/",
};
